import {useMemo} from 'react';

import {MoneyCard} from '~/shared/services/bffService/api/interfaces/responses';
import {
  linkCreditCardHandler,
  manageBillingPermissions,
  moneycardLostOrStolen,
  moneycardWornOrNotWorking,
} from '~/personalArea/components/Sections/MyTenbis/actions';
import {MoneycardOtlRuleManagement} from '~/shared/store/models';

type UseMyTenbisActionsProps = {
  currentMoneycard: MoneyCard | null;
  otlData: MoneycardOtlRuleManagement | null;
  fetchOtl: () => Promise<MoneycardOtlRuleManagement | null>;
  refetchPayments: () => Promise<void>;
};

const useMyTenbisActions = ({currentMoneycard, otlData, fetchOtl, refetchPayments}: UseMyTenbisActionsProps) => {
  return useMemo(() => (!currentMoneycard ? [] : [
    {
      key: 'link_credit_card',
      caption: otlData?.otlRule.ruleActive && otlData?.otlRule.creditcardId ? 'credit_card_link_settings' : 'link_credit_card_to_10bis',
      onClick: () => {
        linkCreditCardHandler(currentMoneycard, otlData, fetchOtl, refetchPayments);
      },
    },
    ...(currentMoneycard.isBillingPermissionsEnabled ? [{
      key: 'billing_permissions',
      caption: 'manage_billing_permissions',
      onClick: () => {
        manageBillingPermissions(currentMoneycard);
      },
    }] : []),
    ...(!currentMoneycard.isWalletCard ? [
      ...(currentMoneycard.isNewCardRequestEnabled ? [
        {
          key: 'card_lost_or_stolen',
          caption: 'card_lost_or_stolen',
          onClick: () => {
            moneycardLostOrStolen(currentMoneycard, refetchPayments);
          },
        },
        {
          key: 'card_worn_or_not_working',
          caption: 'card_worn_or_not_working',
          onClick: () => {
            moneycardWornOrNotWorking(currentMoneycard, refetchPayments);
          },
        },
      ] : []),
    ] : []),
  ]), [currentMoneycard, otlData, fetchOtl, refetchPayments]);
};

export default useMyTenbisActions;
